import styled from '@emotion/styled';
import { Color } from '../../../../styles/Color';
import { Z_INDEX_NAVIGATION_MENU } from '../../../../styles/zIndex';
import { Css } from '../../../../ui';
import { theme } from '../../../../styles/theme';
import { getGradientBackground } from '../../../../styles/gradients';
import { getIconStrokeStyles } from '../../../../styles/getIconStrokeStyles';
import Button from '../../button/Button';
import { openMenu } from '../../../../styles/animation/openMenu';

const MOBILE_MENU_MARGIN = Css.pxToRem(16);

export const MobileMenu = styled.div<{ open: boolean; stickyTop: number }>`
	overflow-y: auto;
	pointer-events: all;

	position: fixed;
	top: ${({ stickyTop }) => Css.pxToRem(stickyTop)};
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${Color.PrimaryWhite};
	z-index: ${Z_INDEX_NAVIGATION_MENU};

	${({ open }) => openMenu(open)}
`;

export const MobileHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: ${Color.PrimaryWhite};
	padding: ${Css.pxToRem(29)} ${Css.pxToRem(24)} ${MOBILE_MENU_MARGIN};
	${getIconStrokeStyles()}
	${getGradientBackground('blue-blue')};
`;

export const MenuLabel = styled.p`
	font-weight: 500;
	font-size: ${theme.typography?.body?.size};
	margin: 0;
`;

export const MenuCloseButton = styled(Button)`
	display: flex;
	gap: 0;
	padding: 0;
	height: ${Css.pxToRem(24)};
`;

export const List = styled.ul`
	display: flex;
	gap: ${Css.pxToRem(8)};
	margin: 0;
	padding: ${MOBILE_MENU_MARGIN};
	list-style: none;
`;
